import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 161 160" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.5 22C112.533 22 138.5 47.9673 138.5 80C138.5 112.033 112.533 138 80.5 138C48.4673 138 22.5 112.033 22.5 80C22.5 47.9673 48.4673 22 80.5 22ZM80.5 31.6664C72.8179 31.6664 65.5548 33.4586 59.1052 36.6472L51.616 58.6328L37.1225 58.656C33.9492 65.0926 32.1664 72.3382 32.1664 79.9993C32.1664 83.5735 32.5543 87.0579 33.2909 90.411L54.3232 104.355L49.193 116.824C56.9817 123.453 66.9005 127.654 77.7784 128.257L94.0814 113.833L103.99 122.251C114.966 116.135 123.312 105.867 126.902 93.5698L116.633 73.0574L126.749 65.9154C124.324 57.9404 119.892 50.839 114.042 45.1993H89.6604L86.5291 32.0384C84.5542 31.7926 82.5416 31.6664 80.5 31.6664ZM79.4567 56.8L100.529 72.1098L92.4799 96.8816H66.4336L58.3846 72.1098L79.4567 56.8Z"
      fill="#E6E6E6"
    />
  </svg>
);

const IconFootballGrey = (props: IIcon & ReactProps) => <Icon color="medium-light" svg={svg} {...props} />;

export default IconFootballGrey;
